import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';
import { EvictorConfig } from '@cast/types-workload-eviction';

import { getEvictorConfigQueryKey } from '../queries/useEvictorConfigQuery';

type Args = {
  clusterId: string;
  config: EvictorConfig;
};

export const useEvictorConfigMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (args: Args) =>
      apiClient.workloadEviction.updateConfig({
        clusterId: args.clusterId,
        config: args.config,
      }),
    onSuccess: ({ data: updatedConfig }, args) => {
      const queryKey = getEvictorConfigQueryKey({ clusterId: args.clusterId });
      queryClient.setQueryData(queryKey, updatedConfig);
    },
  });
};
